<div class="container-fluid form-section content-padded">
  <ng-container *ngIf="_reload">
    <div class="row justify-content-center">
      <div class="col-md-12">
        <div class="form" *ngIf="formData">
          <div class="row">
            <div class="col-sm-10">
              <h1 class="form-title">{{formData.label}}</h1>
            </div>
            <div class="col-sm-2" *ngIf="formData.multipleLanguage">
              <select id="language" name="idLanguage" class="form-control csc-select" (change)="changeLanguage()" [(ngModel)]="languageId">
                <option *ngFor="let l of languages" [ngValue]="l.idLanguage">{{l.name}}</option>
              </select>
            </div>
          </div>
          <div class="row progress-form">
            <span class="col-md-2 pager">Page {{formData.currentPageOrder}} / {{formData.totalPages}}</span>
            <div class="col-md-8">
              <div class="progress">
                <div class="progress-bar csc-progress-bar" role="progressbar" [style.width]="getFormPercentage()+'%'" [attr.aria-valuenow]="getFormPercentage()"
                  aria-valuemin="0" aria-valuemax="100"></div>
              </div>
            </div>
          </div>
          <div class="section">
            {{formData.pageLabel}}
          </div>
          <div class="item" *ngFor="let formItem of formData.formInstanceItem; let i = index" [ngSwitch]="formItem.item.type">
            <div *ngIf="!formItem.item.isHidden">
              <app-datetime *ngSwitchCase="2" [formItem]="formItem" [formId]="formData.id" [(invalidForm)]="invalidForm[i]" (callUpdate)="handleCallUpdate($event, formItem)"></app-datetime>

              <app-textbox *ngSwitchCase="3" [formItem]="formItem" [formId]="formData.id" [(invalidForm)]="invalidForm[i]" (callUpdate)="handleCallUpdate($event, formItem)"></app-textbox>

              <app-radio-button *ngSwitchCase="4" [formItem]="formItem" [formId]="formData.id" [(invalidForm)]="invalidForm[i]" (callUpdate)="handleCallUpdate($event, formItem)"></app-radio-button>



              <app-checkbox-fragment *ngSwitchCase="5" [formItem]="formItem" [formId]="formData.id" (callUpdate)="handleCallUpdate($event, formItem)"></app-checkbox-fragment>

              <app-combobox *ngSwitchCase="6" [formItem]="formItem" [formId]="formData.id" [(invalidForm)]="invalidForm[i]" (callUpdate)="handleCallUpdate($event, formItem)"></app-combobox>

              <div class="item-section" *ngSwitchCase="10">

                <div class="row">
                  <div class="col">
                    <app-label [formItem]="formItem" [formId]="formData.id"></app-label>
                    <app-audioplayer *ngIf="formItem?.item?.allowAudio && formItem?.item?.audioFileName != '' && formItem.item?.audioFileName != null " [formItem]="formItem"></app-audioplayer>
                  </div>
                </div>

                <div *ngFor="let sectionItem of formItem.formListInstanceItem" [ngSwitch]="sectionItem.item.type" class="item">


                  <app-datetime *ngSwitchCase="2" [formItem]="sectionItem" [formId]="formData.id" [(invalidForm)]="invalidForm[i]" (callUpdate)="handleCallUpdate($event, formItem)"></app-datetime>

                  <app-textbox *ngSwitchCase="3" [formItem]="sectionItem" [formId]="formData.id" [(invalidForm)]="invalidForm[i]" (callUpdate)="handleCallUpdate($event, formItem)"></app-textbox>

                  <app-radio-button *ngSwitchCase="4" [formItem]="sectionItem" [formId]="formData.id" [(invalidForm)]="invalidForm[i]" (callUpdate)="handleCallUpdate($event, formItem)"></app-radio-button>

                  <app-checkbox-fragment *ngSwitchCase="5" [formItem]="formItem" [formId]="formData.id" (callUpdate)="handleCallUpdate($event, formItem)"></app-checkbox-fragment>

                  <app-label *ngSwitchCase="15" [formItem]="sectionItem" [formId]="formData.id"></app-label>

                  <app-radio-button-table *ngSwitchCase="19" [formItem]="sectionItem" [formId]="formData.id" [(invalidForm)]="invalidForm[i]" (callUpdate)="handleCallUpdate($event, formItem)"></app-radio-button-table>

                  <app-checkbox-table *ngSwitchCase="50" [formItem]="sectionItem" [formId]="formData.id" [(invalidForm)]="invalidForm[i]" (callUpdate)="handleCallUpdate($event, formItem)"></app-checkbox-table>

                  <app-body *ngSwitchCase="11" [formItem]="sectionItem" [formId]="formData.id" [(invalidForm)]="invalidForm[i]" (callUpdate)="handleCallUpdate($event, formItem)"></app-body>

                </div>
              </div>

              <app-body *ngSwitchCase="11" [formItem]="formItem" [formId]="formData.id" [(invalidForm)]="invalidForm[i]" (callUpdate)="handleCallUpdate($event, formItem)"></app-body>

              <app-label *ngSwitchCase="15" [formItem]="formItem" [formId]="formData.id"></app-label>

              <app-radio-button-table *ngSwitchCase="19" [formItem]="formItem" [formId]="formData.id" [(invalidForm)]="invalidForm[i]" (callUpdate)="handleCallUpdate($event, formItem)"></app-radio-button-table>

              <app-checkbox-table *ngSwitchCase="50" [formItem]="formItem" [formId]="formData.id" [(invalidForm)]="invalidForm[i]" (callUpdate)="handleCallUpdate($event, formItem)"></app-checkbox-table>

            </div>
          </div>
          <div class="paginator">
            <button class="btn btn-lg btn-csc-primary" (click)="prevPage()" *ngIf="formData.prevPageId">
              <i class="bi bi-arrow-left back-button-icon" aria-hidden="true"></i> {{'Back' | translate}}
            </button>
            <button class="btn btn-lg btn-csc-primary" (click)="nextPage()" *ngIf="formData.nextPageId; else submit" [style.left]="((!formData.prevPageId)?'80%':'')">{{'Next' | translate}}
              <i class="bi bi-arrow-right next-button-icon" aria-hidden="true"></i>
            </button>
            <ng-template #submit>
              <button class="btn btn-lg btn-csc-primary finish-button"  [disabled]="buttonFinishDisabled" (click)="finishForm()">{{'Finish' | translate}}</button>
            </ng-template>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</div>
